import axios from "axios";
import { BACKEND_API } from "./ApiConfig";

export default axios.create({
  baseURL: BACKEND_API,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
